import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "@emotion/styled"
import { Container, Box, Flex } from "theme-ui"
import { Link } from "gatsby"
import { useBreakpointIndex } from "@theme-ui/match-media"

const TextImage = styled.div`
    background: ${(props) => props.theme.colors.background};
`
const ImageWrapper = styled.div`
    position: relative;
    max-width: 960px;
    overflow: hidden;

    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        width: 400px;
        height: 400px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        width: 400px;
        height: 400px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[5]}) {
        width: 350px;
        height: 350px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        width: 100%;
        height: auto;
        margin-top: 0;
    }
`

const ContainerHelp = styled(Container)`
    display: flex;
    flex-direction: row;
    margin-bottom: 3rem;
    margin-left: calc(50% - 50vw);

    & h3 {
        color: ${(props) => props.theme.colors.primary};
    }
    & p {
        margin-bottom: 0;
    }
    & a.explore-more {
        background: ${(props) => props.theme.colors.secondary};
        color: ${(props) => props.theme.colors.background};
        margin-top: 1rem;
        padding: 0.5rem 0.75rem;
        text-decoration: none;
        text-align: right;
        justify-content: left;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[7]}) {
        padding: 3rem 2rem;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        flex-direction: column;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        padding: 3rem 1rem;
        & .arrow-wrapper {
            flex: 0 0 70%;
        }
    }
`

const TextWithImage = (props) => {
    const { data } = props
    const breakpoint = useBreakpointIndex()

    return (
        <TextImage>
            <ContainerHelp>
                <Box sx={{ flex: "0 0 50%", textAlign: "center" }}>
                    <ImageWrapper>
                        <GatsbyImage
                            image={getImage(data.imageFile)}
                            alt={data.title}
                            className="content-img"
                        />
                    </ImageWrapper>
                </Box>
                <Box sx={{ flex: "0 0 50%", px: breakpoint > 4 ? "3rem" : 0 }}>
                    <div dangerouslySetInnerHTML={{ __html: data.content }} />
                    <Flex>
                        <Flex
                            sx={{ flex: "0 0 100%", justifyContent: "start" }}
                        >
                            <Link
                                to="/get-started/our-service"
                                className="explore-more content-paragraph arrow-link"
                            >
                                Find Out More
                            </Link>
                        </Flex>
                    </Flex>
                </Box>
            </ContainerHelp>
        </TextImage>
    )
}

export default TextWithImage
